import { PosVendaProtocolosFiltros } from '../../types/posVenda';
import {
  isFiltroConcluidosHoje,
  periodoConclusaoHoje,
} from './posVendaKanbanUtils';
export type GestorKpiFiltroTipo = 'emRisco' | 'vencidos' | 'abertos' | 'concluidosHoje';

/** Remove preset Concluídos hoje (status + período de conclusão hoje). */
export function stripFiltroConcluidosHoje(filtros: PosVendaProtocolosFiltros): PosVendaProtocolosFiltros {
  if (!isFiltroConcluidosHoje(filtros)) return filtros;
  return {
    ...filtros,
    status: '',
    periodoCampo: 'insercao',
    periodoDe: undefined,
    periodoAte: undefined,
    periodoDeUtc: undefined,
    periodoAteUtc: undefined,
    from: undefined,
    to: undefined,
  };
}

/**
 * Próximo estado de filtros após clique em card KPI (toggle ao repetir o mesmo card).
 * Cards legados (Abertos / SLA) não alteram visualização — só Concluídos hoje abre tabela no page.
 */
export function proximosFiltrosGestorKpi(
  tipo: GestorKpiFiltroTipo,
  filtros: PosVendaProtocolosFiltros
): PosVendaProtocolosFiltros {
  if (tipo === 'concluidosHoje') {
    if (isFiltroConcluidosHoje(filtros)) return stripFiltroConcluidosHoje(filtros);
    return {
      ...filtros,
      status: 'Concluido',
      slaEstado: '',
      ...periodoConclusaoHoje(),
    };
  }

  const base = stripFiltroConcluidosHoje(filtros);

  if (tipo === 'emRisco') {
    if (base.slaEstado === 'EmRisco') return { ...base, slaEstado: '' };
    return { ...base, slaEstado: 'EmRisco' };
  }
  if (tipo === 'vencidos') {
    if (base.slaEstado === 'Vencido') return { ...base, slaEstado: '' };
    return { ...base, slaEstado: 'Vencido' };
  }
  if (tipo === 'abertos') {
    return { ...base, slaEstado: '', status: '' };
  }
  return filtros;
}

/** Filtros compartilhados enviados aos KPIs (sem paginação nem filtros de listagem). */
export function filtrosParaKpisApi(filtros: PosVendaProtocolosFiltros): PosVendaProtocolosFiltros {
  const {
    escopo: _escopo,
    page: _page,
    pageSize: _pageSize,
    status: _status,
    slaEstado: _sla,
    ...shared
  } = filtros;

  if (!isFiltroConcluidosHoje(filtros)) return shared;

  const {
    periodoCampo: _pc,
    periodoDe: _pd,
    periodoAte: _pa,
    periodoDeUtc: _pdu,
    periodoAteUtc: _pau,
    from: _from,
    to: _to,
    ...semPeriodoConcluidosHoje
  } = shared;

  return semPeriodoConcluidosHoje;
}
